// src/components/CheckoutModal.jsx
import { useEffect, useRef, useState } from "react";

export default function CheckoutModal({ open, onClose, checkoutUrl, title = "Secure Checkout" }) {
  const [loaded, setLoaded] = useState(false);
  const containerRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // Prevent background scroll while open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  // Reset loader between opens
  useEffect(() => { setLoaded(false); }, [checkoutUrl, open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      {/* Panel */}
      <div
        ref={containerRef}
        className="relative z-10 w-[94vw] h-[90vh] max-w-5xl rounded-2xl bg-white text-black shadow-2xl overflow-hidden"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-black/10">
          <div className="text-sm text-gray-600">{title}</div>
          <button
            onClick={onClose}
            className="rounded-md px-2 py-1 text-sm hover:bg-black/5"
            aria-label="Close checkout"
            type="button"
          >
            ✕
          </button>
        </div>

        {/* Loader */}
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-white">
            <div className="animate-spin h-10 w-10 rounded-full border-4 border-black/20 border-t-black" />
          </div>
        )}

        {/* Iframe */}
        <iframe
          title="Checkout"
          src={checkoutUrl}
          className="w-full h-[calc(90vh-44px)]"
          frameBorder="0"
          onLoad={() => setLoaded(true)}
          allow="payment *; clipboard-read; clipboard-write; autoplay; fullscreen"
        />
      </div>
    </div>
  );
}
